import { CloseOutlined } from '@ant-design/icons';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { getUsername } from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';
import { Input } from 'antd';
import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import '../../styles/NewContactSelectList.less';
import { AddIcon, CallIcon, CloseIcon } from './Icons';
import Loading from './Loading';
import NewContact from './NewContact';

const getSelectedListStyle = (onlySelected) => {
  return {
    ...(onlySelected ? {} : { maxHeight: '50%' }),
  };
};

const NewContactSelectList = ({
  style,
  className,
  fetchingContacts = false,
  displayOnlySelected = false,
  selectedListHeader = 'In Call',
  selectionListHeader = 'Add Contacts',
  selectedContactList = [],
  selectionContactList = [],
  showAddIcon = true,
  showRemoveIcon = true,
  onAddClick = () => {},
  onRemoveClick = () => {},
  onAddAllContacts = () => {},
  selectedContactProps = {},
  selectionContactProps = {},
  showRelationship = true,
  showAddIconCondition = () => true,
  showRemoveIconCondition = () => true,
  assignStaffAction = false,
  selectedUser = '',
  hubRecord = {},
  starteventAction = false,
  principalRecord = {},
}) => {
  const trans = useSelector(translator);
  const isEmpty = assignStaffAction
    ? selectedContactList !== null
    : Array.isArray(selectedContactList) && selectedContactList.length !== 0;
  const [showAllContacts, setShowAllContacts] = useState(false);
  const [searchText, setSearchText] = useState('');
  const searchApplied = !!searchText.trim();

  // Determine the list of contacts to display
  const displayedContacts = selectionContactList;

  const filteredContacts = useMemo(() => {
    if (!searchApplied) return selectionContactList;
    const query = searchText.toLowerCase();
    return selectionContactList.filter((contact) =>
      getUsername(contact).toLowerCase().includes(query)
    );
  }, [searchApplied, searchText, selectionContactList]);

  const handleClearSearch = () => {
    setSearchText('');
  };
  return (
    <div style={style} className={`contact-select-list-main-container ${className ?? ''}`}>
      {/* Selected contact list */}
      <div
        className={`${isEmpty ? 'new-selected-list-container' : 'new-selected-list-empty'}`}
        style={getSelectedListStyle(displayOnlySelected)}
      >
        <div className="new-selected-in-call-header">
          <div className="in-call-icon-label-container">
            <CallIcon className="in-call-icon" />
            <span className="new-in-call-label">{trans('INCALL')}</span>
          </div>
        </div>
        <div className="new-contact-scrollable-in-call-container">
          {selectedContactList?.map((item) => (
            <NewContact
              key={'selected_' + item.useruuid}
              className="primary"
              contact={item}
              hubRecord={hubRecord}
              starteventAction={starteventAction}
              actionIcon={
                showRemoveIcon &&
                showRemoveIconCondition(item) && (
                  <CloseIcon className="close-icon" onClick={() => onRemoveClick(item)} />
                )
              }
              showRelationship={true}
              {...selectedContactProps}
              principalRecord={principalRecord}
            />
          ))}
        </div>
      </div>

      {/* add other participants container */}
      {!displayOnlySelected && (
        <>
          {fetchingContacts ? (
            <Loading />
          ) : (
            <div className="new-add-other-participants-container">
              {
                <span className="new-add-other-participants-label">
                  {trans('ADDOTHERPARTICIPANTS')}
                </span>
              }
              {/* "Find a contact" label and search input */}
              <div className="new-contact-container-list">
                <div className="new-contact-search-container">
                  <div className="new-contact-input-search">
                    <Input
                      className="new-search-input"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      // placeholder={`Search from ${selectedUser}s’ contacts`} // Placeholder text for the search input
                      placeholder={trans('FINDACONTACT')}
                      suffix={
                        searchApplied ? (
                          <CloseOutlined onClick={handleClearSearch} title={trans('CLEARSEARCH')} />
                        ) : (
                          <span />
                        )
                      }
                    />
                  </div>
                </div>
                {/* <div className="new-contact-list-scroll"> */}
                {searchApplied && filteredContacts.length === 0 ? (
                  <div className="no-filtered-contacts-container">
                    <span className="no-contact-available">{trans('NOCONTACTSFOUND')}</span>
                  </div>
                ) : (
                  (searchApplied ? filteredContacts : displayedContacts).map((item) => (
                    <NewContact
                      key={'contact_' + item.useruuid}
                      onClick={!item.disabled && (item.onAddIconClick ?? onAddClick)}
                      contact={item}
                      hubRecord={hubRecord}
                      starteventAction={starteventAction}
                      actionIcon={
                        item.addIcon ??
                        (showAddIcon && showAddIconCondition(item) && (
                          <AddIcon className="add-icon" />
                        ))
                      }
                      showRelationship={true}
                      {...selectionContactProps}
                      principalRecord={principalRecord}
                    />
                  ))
                )}
                {/* </div> */}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

NewContactSelectList.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  fetchingContacts: PropTypes.array,
  displayOnlySelected: PropTypes.bool,
  selectedListHeader: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  selectionListHeader: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  selectedContactList: PropTypes.arrayOf(PropTypes.object),
  selectionContactList: PropTypes.arrayOf(PropTypes.object),
  showAddIcon: PropTypes.bool,
  showRemoveIcon: PropTypes.bool,
  onAddClick: PropTypes.func,
  onRemoveClick: PropTypes.func,
  selectedContactProps: PropTypes.object,
  selectionContactProps: PropTypes.object,
  showRelationship: PropTypes.bool,
  onAddAllContacts: PropTypes.func,
  principalRecord: PropTypes.object,
};

export default NewContactSelectList;
